import { faCopy } from '@fortawesome/free-solid-svg-icons';
import '../../CSS/private/LinkCopyBox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function LinkCopyBox(props)
{
  const url = props.url;

  return (

    <div className='slp-link-copy-box'>
      <p className='slp-link-copy-box-link' href={url} target='_blank' rel='noreferrer'>{url}</p>
      <FontAwesomeIcon className='slp-link-copy-box-button' icon={faCopy} onClick={() => navigator.clipboard.writeText(url)}/>
    </div>

  )
}

export default LinkCopyBox;